import {
  AutoComplete,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { listSaleSellers } from "../../../../../../services/salesSeller.service";
import { useWatch } from "react-hook-form";
import { TSalesContractBeneficiaryForm } from "../salesContractBeneficiarySchema";

const translationPath =
  "page.4uSalesContract.registers.salesContractBeneficiary.";

export const SelectSalesSellers = memo(() => {
  const { t } = useTranslation();

  const [options, setOptions] = useState<ISelectType[]>([]);

  const { sendRequest } = useFetch(listSaleSellers);

  const { control } = useFormContext<TSalesContractBeneficiaryForm>();

  const salesChannel = useWatch({
    name: "salesChannel",
    control,
  });

  const fetchOptions = useCallback(async () => {
    if (!salesChannel) return;
    const { data, success } = await sendRequest({
      SalesChannelId: salesChannel.id,
    });
    if (data && success) {
      setOptions(
        data.map((item) => ({
          id: item.id,
          name: item.titleSeller,
        }))
      );
    }
  }, [sendRequest, salesChannel]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  return (
    <AutoComplete
      getOptionLabel={({ name }) => name}
      label={t(translationPath + "sales_seller")}
      size="small"
      name="salesSeller"
      options={options}
      disable={!salesChannel}
    />
  );
});
